module.exports = __webpack_public_path__ + "img/billboard_large.15ffc15d.png";